import { useEffect } from 'react';
import { useMount } from 'react-use';
import { Stack } from '@mui/material';

import '~configs/stripe';

import { FEATURE_FLAGS, STEP } from '~common';
import { LoadingScreen } from '~components/atoms';
import { WithStationOfflineEffect } from '~components/molecules';
import { StepOne, StepThree, StepTwo } from '~components/organisms';
import { StepThree as NewStepThree } from '~components/organisms/new-step-three';
import { WELCOME_BACK_PAGE_PATH } from '~configs';
import { useNavigateInApp } from '~hooks';
import {
  PaymentStepProvider,
  useMainContext,
  useUserPaymentContext,
} from '~providers';
import { checkEnabledFeatureFlag } from '~utils/index';

export const RentalPage = () => {
  const enableNewPaymentFlow = checkEnabledFeatureFlag(
    FEATURE_FLAGS.NEW_WEB_APP_PAYMENT_FLOW,
  );

  const navigate = useNavigateInApp();
  const { step, initialComplete, changeStep } = useMainContext();
  const { paymentInfo, isFetchingPaymentInfo, isFetchedPaymentInfo } =
    useUserPaymentContext();

  useMount(() => {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth', // Scroll smoothly
    });
  });

  /**
   * Navigate effect
   */
  useEffect(() => {
    if (!isFetchedPaymentInfo || isFetchingPaymentInfo) return;

    if (paymentInfo?.paymentMethodId && !enableNewPaymentFlow) {
      if (step != STEP.INPUT_PAYMENT_INFO) {
        navigate(WELCOME_BACK_PAGE_PATH);
      }
    } else {
      changeStep(STEP.INPUT_PAYMENT_INFO);
    }
  }, [
    navigate,
    paymentInfo?.paymentMethodId,
    isFetchedPaymentInfo,
    step,
    changeStep,
    isFetchingPaymentInfo,
    enableNewPaymentFlow,
  ]);

  if (!initialComplete) {
    return <LoadingScreen />;
  }

  return (
    <Stack
      sx={{
        '--container-padding': (theme) => theme.spacing(2.5),
        p: 'var(--container-padding)',
        display: 'grid',
        gap: 3,
      }}
    >
      {step === STEP.INPUT_PHONE_NUMBER && <StepOne />}
      {step === STEP.INPUT_OTP && <StepTwo />}
      {step === STEP.INPUT_PAYMENT_INFO && (
        <WithStationOfflineEffect>
          {enableNewPaymentFlow ? (
            <PaymentStepProvider>
              <NewStepThree />
            </PaymentStepProvider>
          ) : (
            <StepThree />
          )}
        </WithStationOfflineEffect>
      )}
    </Stack>
  );
};
